import { create } from "zustand";
import { persist } from "zustand/middleware";
// import {createJSONStorage} from "zustand/middleware";

const memberClass = () => {
  return {
    id: null,
    memberRefNo: null,
    enrolmentIssueDate: null,
    enrolmentStartDate: null,
    unifiedNo: null,
    emiratesIdNo: null,
    visaFileNo: null,
    birthCertNo: null,
    passportNo: null,
    gender: null,
    nationalityCode: null,
    dateOfBirth: null,
    fullNameEn: null,
    firstNameEn: null,
    middleNameEn: null,
    lastNameEn: null,
    fullNameAr: null,
    firstNameAr: null,
    middleNameAr: null,
    lastNameAr: null,
    maritalStatus: null,
    relationWithSponsor: null,
    memberIdType: null,
    memberType: null,
    sponsorIdNo: null,
    sponsorIdType: null,
    membershipCardNo: null,
    className: null,
    salaryBand: null,
    occupationDesc: null,
    emiratesOfVisaCode: null,
    emiratesOfLivingCode: null,
    memberCreationRefNo: null,
    memberUpdateRefNo: null,
    cancellationDate: null,
    integrationStatus: null,
    status: null,
    createdAt: null,
    updatedAt: null,
  };
};

const useMemberEditStore = create(
  persist(
    (set) => ({
      ...memberClass(),
      setMemberFromGraphQLRequest: (values) =>
        set({
          ...memberClass(),
          ...values,
          enrolmentIssueDate:
            values?.enrolmentIssueDate?.replace(" ", "T").slice(0, 16) ||
            null,
          enrolmentStartDate:
            values?.enrolmentStartDate?.replace(" ", "T").slice(0, 16) ||
            null,
          dateOfBirth: values?.dateOfBirth?.slice(0, 10) || null,
          gender: { Female: "0", Male: "1" }[values?.gender] ?? values?.gender,
          maritalStatus:
            { Married: "1", Single: "2" }[values?.maritalStatus] ??
            values?.maritalStatus,
          relationWithSponsor:
            {
              Applicant: "1",
              Employee: "2",
              Spouse: "3",
              Child: "4",
              Father: "5",
              Mother: "6",
              Sister: "7",
              Brother: "8",
              DomesticWorker: "9",
              Other: "10",
            }[values?.relationWithSponsor] ?? values?.relationWithSponsor,
          memberIdType:
            {
              UnifiedNumber: "1",
              EmiratesIdNumber: "2",
              VisaFileNo: "3",
              PassportNumber: "4",
              BirthCertificateNumber: "5",
            }[values?.memberIdType] ?? values?.memberIdType,
          memberType:
            { Primary: "1", Dependent: "2" }[values?.memberType] ??
            values?.memberType,
          sponsorIdType:
            {
              UnifiedNumber: "1",
              EmiratesIdNumber: "2",
              VisaFileNo: "3",
              PassportNo: "4",
            }[values?.sponsorIdType] ?? values?.sponsorIdType,
        }),
      updateMember: (key, value) => set({ [key]: value }),
      // setMemberRefNo: (value) => set({memberRefNo: value}),
      // setEnrolmentIssueDate: (value) => set({enrolmentIssueDate: value}),
      // setEnrolmentStartDate: (value) => set({enrolmentStartDate: value}),
      // setUnifiedNo: (value) => set({unifiedNo: value}),
      // setEmiratesIdNo: (value) => set({emiratesIdNo: value}),
      // setVisaFileNo: (value) => set({visaFileNo: value}),
      // setBirthCertNo: (value) => set({birthCertNo: value}),
      // setPassportNo: (value) => set({passportNo: value}),
      // setGender: (value) => set({gender: value}),
      // setNationalityCode: (value) => set({nationalityCode: value}),
      // setDateOfBirth: (value) => set({dateOfBirth: value}),
      // setFullNameEn: (value) => set({fullNameEn: value}),
      // setFirstNameEn: (value) => set({firstNameEn: value}),
      // setMiddleNameEn: (value) => set({middleNameEn: value}),
      // setLastNameEn: (value) => set({lastNameEn: value}),
      // setFullNameAr: (value) => set({fullNameAr: value}),
      // setFirstNameAr: (value) => set({firstNameAr: value}),
      // setMiddleNameAr: (value) => set({middleNameAr: value}),
      // setLastNameAr: (value) => set({lastNameAr: value}),
      // setMaritalStatus: (value) => set({maritalStatus: value}),
      // setRelationWithSponsor: (value) => set({relationWithSponsor: value}),
      // setMemberIdType: (value) => set({memberIdType: value}),
      // setMemberType: (value) => set({memberType: value}),
      // setSponsorIdNo: (value) => set({sponsorIdNo: value}),
      // setSponsorIdType: (value) => set({sponsorIdType: value}),
      // setMembershipCardNo: (value) => set({membershipCardNo: value}),
      // setClassName: (value) => set({className: value}),
      // setSalaryBand: (value) => set({salaryBand: value}),
      // setOccupationDesc: (value) => set({occupationDesc: value}),
      // setEmiratesOfVisaCode: (value) => set({emiratesOfVisaCode: value}),
      // setEmiratesOfLivingCode: (value) => set({emiratesOfLivingCode: value}),
      // setMemberCreationRefNo: (value) => set({memberCreationRefNo: value}),
      // setCancellationDate: (value) => set({cancellationDate: value}),
    }),
    {
      name: "x-policy-edit", // name of item in the storage (must be unique)
      //storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
      // partialize: (state) => ({
      // 	integrationType: state.integrationType,
      // }),
    },
  ),
);

export default useMemberEditStore;
